import {
  AddedToCartObjectIDs,
  AddedToCartObjectIDsAfterSearch,
  ClickedObjectIDsAfterSearch,
  InsightsClient,
  insightsClient,
  InsightsEvents,
  ViewedObjectIDs,
} from '@algolia/client-insights'

// These Algolia event IDs aren't required but are for our own benefit.
// @see https://www.algolia.com/doc/rest-api/insights/#tag/events/operation/pushEvents
export enum ALGOLIA_EVENTS {
  CLICK_OBJECT_IDS_AFTER_SEARCH = 'click_object_ids_after_search',
  ADD_TO_CART_OBJECT_IDS_AFTER_SEARCH = 'add_to_cart_object_ids_after_search',
  PURCHASE_OBJECT_IDS_AFTER_SEARCH = 'purchase_object_ids_after_search',
  CONVERT_OBJECT_IDS_AFTER_SEARCH = 'convert_object_ids_after_search',
  CLICK_OBJECT_IDS = 'click_object_ids',
  PURCHASE_OBJECT_IDS = 'purchase_object_ids',
  ADD_TO_CART_OBJECT_IDS = 'add_to_cart_object_ids',
  CONVERT_OBJECT_IDS = 'convert_object_ids',
  CLICK_FILTERS = 'click_filters',
  CONVERT_FILTERS = 'convert_filters',
  VIEW_OBJECT_IDS = 'view_object_ids',
  VIEW_FILTERS = 'view_filters',
}

/**
 * Insights client. Basically a thin wrapper around Algolia Insights API.
 *
 * See https://www.algolia.com/doc/api-client/methods/insights/ for available events (note its
 * documentation about their legacy client, but it's the only list of events we were able to discover).
 *
 * @see https://www.algolia.com/doc/libraries/javascript/v5/methods/insights/
 * @see https://www.algolia.com/doc/rest-api/insights/#tag/events
 */
export const algoliaInsightsClient: InsightsClient = insightsClient(process.env.NEXT_PUBLIC_ALGOLIA_APPLICATION_ID || '', process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_API_KEY || '')

export type { AddedToCartObjectIDs, AddedToCartObjectIDsAfterSearch, ClickedObjectIDsAfterSearch, InsightsEvents, ViewedObjectIDs }
